import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { useBilling } from "@/contexts/BillingContext";
import { Chrome, Star } from "lucide-react";
import { detectExtensionInstalled, getChromeWebStoreUrl } from "@/lib/extension";
import { PlanType } from "@/types/auth";
import Link from "next/link";

/**
 * Billing Badge Component
 * Shows upgrade badge for free users, plan badge for paid users
 */
export function BillingBadge() {
  const { billingData, loading } = useBilling();

  const [isExtensionInstalled, setIsExtensionInstalled] = useState<boolean | null>(null);

  useEffect(() => {
    setIsExtensionInstalled(detectExtensionInstalled());
  }, []);

  if (isExtensionInstalled === false) {
    return (
      <Button
        data-custom-id="add_to_chrome"
        variant="default"
        size="sm"
        className="cursor-pointer h-7 px-2 fade-in animate-in transition-opacity duration-300"
        onClick={() => {
          window.open(getChromeWebStoreUrl(), "_blank");
        }}
      >
        <Chrome className="h-4 w-4" /> Add to Chrome
      </Button>
    );
  }

  // Don't render anything while loading
  if (loading || !billingData || isExtensionInstalled === null) {
    return null;
  }

  const isFreeUser = billingData.planType === PlanType.FREE;
  // For free users, show upgrade badge with link to pricing
  if (isFreeUser) {
    return (
      <Link href="/dashboard/billing#buy-credits">
        <Button
          variant="default"
          size="sm"
          className="cursor-pointer h-7 px-2 fade-in animate-in transition-opacity duration-300"
        >
          <Star fill="currentColor" className="h-4 w-4 text-yellow-500" /> Buy credits
        </Button>
      </Link>
    );
  }

  return null;
}
